export default "__VITE_ASSET__RNW98m4r__"